import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { useEffect, useState } from "react";
import { notificationsContent } from "./features/strapi/componentSlice";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { globalValContent } from "./features/strapi/globalValuesSlice";
import TagManager from "react-gtm-module";
import firebase from "./adapters/firebase";
import EnvConfig from "./config/env.config.json";
import { isDevServer, PasswordAuthenticator } from "./components";
import {
  getCartItems,
  getCustomerFromShopware,
  shopwareAuth,
} from "./features/shopWare/shopWareSlice";
import { shopwareAuthentication } from "./utils/commonFunctions/shopWareFunctions";
import {
  getSubdomain,
  updateThemeVariables,
  ConvertHexToRgbA,
} from "./global/themeutils";
import { getSubDomainDetails } from "./features/homepage/homepageSlice";
import { Coupon } from "./features/checkout/checkoutSlice";
import { getResolutionDetails } from "./utils";
import { RoutingURLs } from "./config/RoutingURLs";
import Cookies from "js-cookie";
import { useCookies } from "react-cookie";

function App() {
  const { subDomainData } = useAppSelector((state: any) => state.homepage);
  const [isPasswordProtect, setIsPasswordProtect] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [brandPassword, setBrandPassword] = useState("");
  const dispatch = useAppDispatch();
  const [isLandscape, setIsLandscape] = useState(false);
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const [cookie, setCookie, removeCookie] = useCookies(["ssoAccessToken"]);

  useEffect(() => {
    const brand = getSubdomain();
    if (brand) {
      dispatch(getSubDomainDetails({ subDomain: brand }));
    }
    if (
      !(
        localStorage.getItem("accessToken") &&
        localStorage.getItem("currentuser")
      )
    ) {
      firebase
        .auth()
        .signInAnonymously()
        .then(async (user) => {
          await localStorage.setItem(
            "currentuser",
            JSON.stringify(user && user.user)
          );
          let user1: any = await localStorage.getItem("currentuser");
          user1 = JSON.parse(user1);
          let token = "";
          user1 &&
            user1.uid &&
            user1.stsTokenManager &&
            user1.stsTokenManager.accessToken;
          await localStorage.setItem("accessToken", token);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    dispatch(globalValContent());
    dispatch(notificationsContent());
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY || "",
    };
    TagManager.initialize(tagManagerArgs);
    if (EnvConfig?.IS_SHOPWARE_ENABLED) {
      let currentuser: any = localStorage.getItem("currentuser");
      currentuser = JSON.parse(currentuser);
      let searchParams = new URLSearchParams(document.location.search);
      let logoutCheck: string | null = searchParams.get("logout");

      if (!logoutCheck) {
        dispatch(getCartItems());
        if (currentuser && currentuser.email) {
          fetchShopwareUser();
        }
      } else {
        if (EnvConfig.IS_SSO_LOGIN) {
          localStorage.clear();
          removeCookie("ssoAccessToken");
          window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_URL}`;
          localStorage.setItem("globalValues", JSON.stringify(globalVal));
          // navigate(RoutingURLs.home);
        } else {
          firebase
            .auth()
            .signOut()
            .then(() => {
              localStorage.clear();
              if (EnvConfig?.IS_SHOPWARE_ENABLED) {
                Cookies.remove("swContextToken");
                dispatch(getCartItems());
                // navigate(RoutingURLs.home);
              } else {
                // navigate(RoutingURLs.home);
              }
              localStorage.setItem("globalValues", JSON.stringify(globalVal));
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }
  }, []);
  useEffect(() => {
    if (subDomainData?.status === "SUCCESS" && subDomainData?.data) {
      localStorage.setItem(
        "subDomainData",
        JSON.stringify(subDomainData?.data)
      );
      const brandPassword = subDomainData?.data?.brandPassword;
      setIsPasswordProtect(brandPassword && brandPassword !== " ");
      setBrandPassword(brandPassword);
      dispatch(
        Coupon({ couponCode: subDomainData?.data?.promoCode.toUpperCase() })
      );
      let themeVariables = {};
      themeVariables = {
        primary_color: ConvertHexToRgbA(subDomainData?.data?.colorCode),
        primary_brand_color: ConvertHexToRgbA(subDomainData?.data?.colorCode),
        success_notification: ConvertHexToRgbA(subDomainData?.data?.colorCode),
        info_notification: ConvertHexToRgbA(subDomainData?.data?.colorCode),
        default_notification: ConvertHexToRgbA(subDomainData?.data?.colorCode),
        app_section_bg_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.1
        ),
        lead_generation_bg_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.2
        ),
        plan_section_bg_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.1
        ),
        faq_background: ConvertHexToRgbA(subDomainData?.data?.colorCode, 0.1),
        login_signup_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.1
        ),
        faq_answer_bg: ConvertHexToRgbA(subDomainData?.data?.colorCode, 0.1),
        primary_brand_color_light: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.4
        ),
        switch_border_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.1
        ),
        light_primary_color: ConvertHexToRgbA(
          subDomainData?.data?.colorCode,
          0.1
        ),
      };
      updateThemeVariables(themeVariables);
    }
  }, [subDomainData]);

  const fetchShopwareUser = () => {
    dispatch(getCustomerFromShopware())
      .then((_res: any) => {})
      .catch((_err: any) => {
        handleLoginShopware();
      });
  };
  const handleLoginShopware = () => {
    let payloadData: any = shopwareAuthentication();
    if (payloadData) {
      dispatch(shopwareAuth(payloadData));
    }
  };
  const landscapeInnerHeight =
    window.innerHeight > 400 && window.innerHeight < 500;
  const landscapeInnerWidth =
    window.innerWidth > 800 && window.innerWidth < 1000;
  const { desktop, mobile } = getResolutionDetails();

  const orientation = window.screen.orientation as any;

  const handleOrientationChange = () => {
    if (
      orientation?.type === globalVal?.landscape &&
      orientation?.angle === globalVal?.landscape_angle
    ) {
      setIsLandscape(true);
    } else {
      setIsLandscape(false);
    }
  };

  useEffect(() => {
    handleOrientationChange();
  }, [orientation?.type, orientation?.angle]);

  let websiteAuth: any = localStorage.getItem("website_auth");
  const { showPasswordAuthenticator } = useAppSelector(
    (state: any) => state.homepage
  );

  useEffect(() => {
    if (websiteAuth === brandPassword) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, [showPasswordAuthenticator]);

  return (
    <>
      {isLandscape ? (
        <div
          style={{ textAlign: "center", padding: "20px", marginTop: "100px" }}
        >
          {globalVal?.landscape_message}
        </div>
      ) : EnvConfig?.WEBSITE_PASSWORD_AUTHENTICATION && isPasswordProtect ? (
        isVerified || websiteAuth ? (
          <AppRoutes />
        ) : (
          <PasswordAuthenticator
            setIsVerified={setIsVerified}
            isVerified={isVerified}
            brandPassword={brandPassword}
          />
        )
      ) : (
        <AppRoutes />
      )}
    </>
  );
}

export default App;
